<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <img src="@/assets/img/logo_mini.png" alt="Logo" />
  </div>
</template>

<script>
export default {
  name: 'Index',

  mounted() {
    if (process.env.NODE_ENV === 'production') {
      window.location.href = window.location.origin
    }
  },
}
</script>

<style scoped>
img {
  animation: fadeInFromNone 2s infinite;
  -webkit-animation: fadeInFromNone 2s infinite;
  -moz-animation: fadeInFromNone 2s infinite;
  -o-animation: fadeInFromNone 2s infinite;
}

@keyframes fadeInFromNone {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

@-webkit-keyframes fadeInFromNone {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

@-moz-keyframes fadeInFromNone {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

@-o-keyframes fadeInFromNone {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}
</style>
